import MegaMenu from './megamenu';
import MobileMenu from './mobilemenu';
import StickyHeader from './sticky-header';
import LayoutHeaderNav from './layout-header-nav';
import Accordion from './accordion';
import Announcement from './announcement';
import Banner from './banner';
import VideoModal from './video-modal';
import Compare from './compare';
import ProductFinder from './product-finder/product-finder';
import ComparePage from './compare-page';
import ProductShowcase from './product-showcase/product-showcase';
import SubscribeForm from './subscribe-form';
import FitGuideModal from './fit-guide-modal';
import Footer from './footer';
import PromoBanner from './promo-banner';
import HeroBanner from './hero-banner';
import FAQsBlock from './faqs-block';
import ProductTabs from './product-tabs/product-tabs';

import { QuickShopButtons } from './product-quickshop/quickshop-component';
import ProductSamples from './product-samples';
import StateSelector from './state-selector/state-selector';
import StateSelectorMenu from './state-selector-menu/state-selector-menu';
import PlpStockBadge from './plp-stock-badge/plp-stock-badge';
import CartStateManager from './cart/cart-state-manager';

export default () => {
  HeroBanner();

  // Bind Compare() to the window object.
  // Access it through the BC-SF-Filter.js
  // Access it through Product-Showcase.js
  window.compare = Compare;
  MegaMenu();
  MobileMenu();
  StickyHeader();
  LayoutHeaderNav();
  Accordion();
  Announcement();
  Banner();
  VideoModal();
  ProductShowcase();
  SubscribeForm();
  ProductFinder();
  ComparePage();
  Footer();

  FitGuideModal();

  QuickShopButtons();

  PromoBanner();
  FAQsBlock();
  ProductTabs();
  ProductSamples();
  StateSelector();
  StateSelectorMenu();
  PlpStockBadge();
  CartStateManager();
};
